const state = {
    messages: {
        required: 'Field is required',
        email: 'Email address is not correct',
        sameAs: 'Passwords must be identical',
        checked: 'Please accept the Terms & Conditions'
    },
    files: [],
    uploaded: null,
    uploadFolder: null,
    uploadHazardId: null
};

const getters = {
    getErrorMessage: (state) => (field) => {
        if (field.hasOwnProperty('required') && !field.required) {
            return state.messages.required;
        }

        if (field.hasOwnProperty('email') && !field.email) {
            return state.messages.email;
        }

        if (field.hasOwnProperty('sameAsPassword') && !field.sameAsPasword) {
            return state.messages.sameAs;
        }

        if (field.hasOwnProperty('checked') && !field.checked) {
            return state.messages.checked;
        }
    }
};

const actions = {
    storeFiles({commit}, payload) {
        commit('SET_FILES', payload.files);
    },
    isUploaded({commit}, payload) {
        commit('SET_UPLOADED', payload.uploaded);
    },
    setUploadFolder({commit}, payload) {
        commit('SET_UPLOAD_FOLDER', payload.folder);
    },
    setUploadHazardId({commit}, payload) {
        commit('SET_UPLOAD_HAZARD_ID', payload.id);
    }

};

const mutations = {
    SET_FILES(state, data) {
        state.files = data;
    },
    SET_UPLOADED(state, data) {
        state.uploaded = data;
    },
    SET_UPLOAD_FOLDER(state, data) {
        console.log(data);
        state.uploadFolder = data;
    },
    SET_UPLOAD_HAZARD_ID(state, data) {
        console.log(data);
        state.uploadHazardId = data;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/form.js